module.exports = __webpack_public_path__ + "static/img/iphone_room2.e9d6af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room2.png
// module id = ueK0
// module chunks = 0